export const bulkEditActions = Object.freeze(
  /** @type {const} */ ({
    APPEND: 'append',
    REPLACE: 'replace',
    REMOVE: 'remove',
    UPDATE_CERT_ONLY: 'update-cert-only',
  })
);

export const allowedBulkEditActions = Object.values(bulkEditActions);
